import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { getSiteConfig } from "@/siteConfig";

const links = [
    { label: "Product", href: "/#features" },
    { label: "Workflow", href: "/#workflow" },
    { label: "Showcase", href: "/#showcase" },
    { label: "Customers", href: "/#testimonials" },
    { label: "Pricing", href: "/pricing" },
    { label: "FAQ", href: "/#faq" },
];

export default function Nav() {
    const [open, setOpen] = useState(false);
    const { version } = getSiteConfig();
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 bg-bg/95 backdrop-blur border-b border-border"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
                <a
                    href="/"
                    data-testid="nav-logo"
                    className="flex items-center gap-2"
                >
                    <span className="font-display text-[22px] font-black tracking-tighter">
                        ReachForge
                    </span>
                    <span className="hidden md:inline overline mt-1">
                        / Leads · v{version}
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            href={l.href}
                            className="text-sm font-medium text-ink-soft hover:text-ink link-underline transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <Link
                        to="/login"
                        data-testid="nav-cta-signin"
                        className="hidden md:inline-flex text-sm font-medium text-ink hover:text-forge link-underline"
                    >
                        Sign in
                    </Link>
                    <a
                        data-testid="nav-cta-free-month"
                        href="/checkout?plan=free_month"
                        className="btn btn-primary h-10"
                    >
                        Free Month <ArrowUpRight size={14} />
                    </a>
                    <button
                        data-testid="nav-mobile-toggle"
                        className="md:hidden h-10 w-10 border border-ink flex items-center justify-center"
                        onClick={() => setOpen((v) => !v)}
                        aria-label="Menu"
                    >
                        {open ? <X size={18} /> : <Menu size={18} />}
                    </button>
                </div>
            </div>
            {open && (
                <div className="md:hidden border-t border-border bg-bg">
                    <div className="px-6 py-4 flex flex-col gap-3">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="text-sm font-medium py-2"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="/checkout?plan=free_month"
                            onClick={() => setOpen(false)}
                            className="text-sm font-medium py-2"
                        >
                            Free Month
                        </a>
                        <Link
                            to="/login"
                            onClick={() => setOpen(false)}
                            className="text-sm font-medium py-2"
                        >
                            Sign in
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
